import { render, staticRenderFns } from "./MobEsgRating.vue?vue&type=template&id=507edcf6&scoped=true"
import script from "./MobEsgRating.vue?vue&type=script&setup=true&lang=js"
export * from "./MobEsgRating.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobEsgRating.vue?vue&type=style&index=0&id=507edcf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507edcf6",
  null
  
)

export default component.exports